import CustomQuestionnaire from "components/CustomQuestionnaire/CustomQuestionnaire";
import CustomSuspense from "components/CustomSuspense/CustomSuspense";
import { CenterQuestionnaireContent } from "components/InAppQuestionnaire/InAppQuestionnaire";
import styled from "@emotion/styled";
import type { FC } from "react";
import { ONBOARDING_QUESTIONNAIRE_INITIAL_LAB } from "src/constants/misc";
import Track from "../Track/Track";

const QuestionnaireWrapper = styled(CenterQuestionnaireContent)`
  nine-funnel-step {
    --funnel-step-padding: 4rem var(--space-md);
  }
`;

interface QuestionnaireStepProps {
  onDataSent: () => void;
  onLastStepCompleted: () => void;
}

const InitialLabsQuestionnaireStep: FC<QuestionnaireStepProps> = ({
  onDataSent,
  onLastStepCompleted
}) => {
  return (
    <QuestionnaireWrapper>
      <Track event="Initial Labs Dialog Questionnaire Shown" />
      <CustomSuspense>
        <CustomQuestionnaire
          resetScrollOnEachStep
          id={ONBOARDING_QUESTIONNAIRE_INITIAL_LAB}
          useRouting
          onDataSent={onDataSent}
          onLastStepCompleted={onLastStepCompleted}
        />
      </CustomSuspense>
    </QuestionnaireWrapper>
  );
};

export default InitialLabsQuestionnaireStep;
